// Charge la base commune
import './common.js'

// Contact Form
async function getCForm($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion du formulaire de contact
  const $c1 = $('form[name="cForm"]')
  if ($c1.length) {
    $c1.waypoint(
      function () {
        getCForm($c1)
        this.destroy()
      },
      {
        offset: '100%',
      }
    )
  }

  const $go = $('#go')
  if ($go.length) {
    $('html').animate(
      { scrollTop: $go.offset().top - $('#header').height() - 40 },
      { duration: 300, easing: 'linear' },
      function () {
        $('html').animate(
          { scrollTop: $go.offset().top - $('#header').height() - 40 },
          { duration: 300, easing: 'linear' }
        )
      }
    )
  }
})
